// extracted by mini-css-extract-plugin
export default {"downloadButton":"ReportTableV2_downloadButton__NCcFB","buttonFont":"ReportTableV2_buttonFont__zWP3U"};